import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=28c3f39b&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=28c3f39b&prod&lang=css"
import style1 from "./_id.vue?vue&type=style&index=1&id=28c3f39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3f39b",
  null
  
)

export default component.exports